import { render, staticRenderFns } from "./deliveryCell.vue?vue&type=template&id=9d1e4b56&scoped=true"
import script from "./deliveryCell.vue?vue&type=script&lang=js"
export * from "./deliveryCell.vue?vue&type=script&lang=js"
import style0 from "./deliveryCell.vue?vue&type=style&index=0&id=9d1e4b56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1e4b56",
  null
  
)

export default component.exports